import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFootsteps: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFootsteps"><Path d="M10.0502 14.5H4.05021L4 16C4 17.6569 5.34315 19 7 19C8.65685 19 10 17.6569 10 16L10.0502 14.5Z" fill="currentColor"/><Path d="M9.94982 13H4.05021C2.17158 9.7 2.61639 2 6.99985 2C11.3833 2 11.8286 9.7 9.94982 13Z" fill="currentColor"/><Path d="M19.9498 16H14.0502C12.1716 12.7 12.6164 5 16.9998 5C21.3833 5 21.8286 12.7 19.9498 16Z" fill="currentColor"/><Path d="M20 17.5H14V19C14 20.6569 15.3431 22 17 22C18.6569 22 20 20.6569 20 19V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFootsteps;
